angular.module('app').component('teamTesters', {
    templateUrl: 'scripts/app/partials/TeamAdmin/team-testers.tpl.html',
    controller: 'TeamTestersController',
    controllerAs: 'vm'
});
//# sourceMappingURL=team-testers.component.js.map